import { useSnackbar } from 'notistack';
import { useForm } from 'react-hook-form';
import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';

import { Box, Grid, Stack, Container } from '@mui/material';

import { paths } from 'src/routes/routes/paths';

import { useResponsive } from 'src/hooks/use-responsive';

import { MetaHelmet } from 'src/layouts/Helmet/Helmet';
import { getAdvertiserProfile } from 'src/server/store/auth';

import FormProvider from 'src/components/hook-form';
import { useSettingsContext } from 'src/components/settings';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs';
import RHFTextField from 'src/components/hook-form/rhf-text-field';

import ExecutionLogs from 'src/sections/automation/ExecutionLogs';
import CustomDateRangeInput from 'src/sections/analytics/CustomDateRangeInput';

function ExecutionLogPage() {
  const settings = useSettingsContext();
  const isMobile = useResponsive('down', 'sm');

  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();

  const { advertiserAccountDetails } = useSelector((state) => ({
    advertiserAccountDetails: state?.auth?.advertiserProfileDetails?.profile,
  }));

  useEffect(() => {
    const credentialsYear = {
      enqueueSnackbar,
    };
    dispatch(getAdvertiserProfile(credentialsYear));
  }, [dispatch, enqueueSnackbar]);

  const [formattedDate, setFormattedDate] = useState({
    from: '',
    to: '',
  });

  const [date, setDate] = useState([
    {
      startDate: '',
      endDate: '',
      key: 'selection',
    },
  ]);

  console.log(formattedDate); // pass to the api

  const methods = useForm();

  return (
    <>
      <MetaHelmet title="Execution Logs" />
      <Container maxWidth={settings.themeStretch ? false : 'xl'}>
        <Box
          display={isMobile ? '' : 'flex'}
          alignItems="center"
          justifyContent={isMobile ? '' : 'space-between'}
          width="100%"
        >
          <Stack>
            <CustomBreadcrumbs
              heading="Execution Logs"
              links={[
                {
                  name: 'Dashboard',
                  href: paths.dashboard.root,
                },
                {
                  name: 'Execution Logs',
                },
              ]}
              sx={{
                mb: { xs: 3, md: 5 },
              }}
            />
          </Stack>

          <Stack direction="row" alignItems="center" justifyContent="">
            <Stack>
              <CustomDateRangeInput
                date={date}
                setDate={setDate}
                setFormattedDate={setFormattedDate}
              />
            </Stack>
            <Stack>
              <Grid item className="adAccountFields">
                <FormProvider methods={methods}>
                  <RHFTextField
                    name="name"
                    size="small"
                    showimg
                    showimg2
                    data={advertiserAccountDetails}
                  />
                </FormProvider>
              </Grid>
            </Stack>
          </Stack>
        </Box>
        <ExecutionLogs formattedDate={formattedDate} />
      </Container>
    </>
  );
}

export default ExecutionLogPage;
